export const latitudeRegex = /^-?(90(\.0+)?|[0-8]?\d(\.\d+)?)$/;
export const longitudeRegex = /^-?(180(\.0+)?|1[0-7]\d(\.\d+)?|[0-9]?\d(\.\d+)?)$/;

export const nameValidationRegex =
  /^[\u3040-\u309F\u30A0-\u30FF\uFF66-\uFF9F\u4E00-\u9FFF\u3400-\u4DBF\u0041-\u005A\u0061-\u007A\u0030-\u0039 \u30FC\uFF0D\u2010\u2013\u2014\u2015\u301C\u0020\u3000]+$/;

export const descriptionRegex =
  /^[\u3040-\u309F\u30A0-\u30FF\u4E00-\u9FFF\u3400-\u4DBF\u0041-\u005A\u0061-\u007A\u0030-\u0039 ., \u30FC\uFF0D\u2010\u2013\u2014\u2015\u301C\u3000]+$/;

export const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[A-Za-z]{2,}$/;
export const mobileNumberRegex = /^(090|080|070)\d{7,8}$/;

export const landlineNumberRegex = /^\d{10,11}$/;

export const instagramUrlRegex = /^(https?:\/\/)?(www\.)?instagram\.com\/.+$/i;

export const tiktokUrlRegex = /^(https?:\/\/)?(www\.)?tiktok\.com\/.+$/i;

export const lineUrlRegex = /^(https?:\/\/)?(www\.)?(line\.me|lin\.ee)(\/.+)?$/i;

export const twitterUrlRegex = /^(https?:\/\/)?(www\.)?(twitter\.com|x\.com)\/.+$/i;

export const websiteUrlRegex = /^(https?:\/\/)?([\w-]+\.)+[\w-]{2,}(\/.*)?$/i;

export const googleMapUrlRegex =
  /^(https?:\/\/)?(www\.)?(maps\.google\.com|google\.com\/maps|goo\.gl\/maps|maps\.app\.goo\.gl)\/.+$/i;
